// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vulZ","col":"styles_col__3qpJk"};